/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import { pluck, pluckNumber, getValidValue, getDashStyle, getFirstColor,
  parseUnsafeString, preDefStr, parseTooltext } from '@fusioncharts/core/src/lib';

import ErrorBar2DDataset from '../../dataset/errorbar2d';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import candlestickAnimation from './candlestick.animation';
import { _removePlots } from '@fusioncharts/charts/src/dataset/column';

let colorStrings = preDefStr.colors,
  COLOR_B90000 = colorStrings.B90000,
  COLOR_FFFFFF = colorStrings.FFFFFF,
  BLANKSTRING = '',
  UNDEF,
  DASH_DEF = 'none',
  POINTER = 'pointer',
  DEFAULT_CURSOR = 'default',
  SHOWSHADOW = 'showShadow',
  ROLLOVER = 'DataPlotRollOver',
  ROLLOUT = 'DataPlotRollOut',
  LINE = 'line',
  BOLDSTARTTAG = '<b>',
  BOLDENDTAG = '</b>',
  BLANKSPACE = ' ',
  BREAKSTRING = '<br />',
  /**
   * This method handles all mouse events of an dataset.
   * @param {string} eventType    name of the event
   * @param {number} plotIndex    index of the plot where this event has been occured
   * @param {Event}  e            reference of the original mouse event
   */
  _firePlotEvent = function (eventType, plotIndex, e) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      dataStore = dataset.components.data, // eslint-disable-line good-practices/no-single-usage-variable
      data = dataStore[plotIndex],
      toolText,
      currentToolTip = dataset.config.currentToolTip,
      setElement = data.graphics.element,
      originalEvent = e.originalEvent,
      style = chart.getFromEnv('paper').canvas.style,
      toolTipController = dataset.getFromEnv('toolTipController'),
      config,
      setLink;
    if (setElement) {
      config = data.config;
      toolText = config.toolText;
      setLink = config.setLink;
      switch (eventType) {
        case 'fc-mouseover' :
          if (toolText) {
            if (currentToolTip) {
              toolTipController.draw(originalEvent, toolText, currentToolTip);
            } else {
              currentToolTip = dataset.config.currentToolTip =
                toolTipController.draw(originalEvent, toolText);
            }
          }
          chart.plotEventHandler(setElement, e, ROLLOVER);
          setLink && (style.cursor = POINTER);
          break;
        case 'fc-mouseout' :
          toolTipController.hide(currentToolTip);
          chart.plotEventHandler(setElement, e, ROLLOUT);
          setLink && (style.cursor = DEFAULT_CURSOR);
          break;
        case 'fc-click' :
          chart.plotEventHandler(setElement, e);
          break;
        case 'fc-mousemove' :
          if (toolText) {
            if (currentToolTip) {
              toolTipController.draw(originalEvent, toolText, currentToolTip);
            } else {
              currentToolTip = dataset.config.currentToolTip = toolTipController.draw(originalEvent, toolText);
            }
          }
      }
    }
  },
  /**
   * fetches data indices wrt. the x pos value
   * @param {number} x  x pos value
   * @return {Array}    contains indices
   */
  getPlotIndices = function (x) {
    var dataset = this,
      i,
      minX = Math.floor(x), // eslint-disable-line good-practices/no-single-usage-variable
      maxX = Math.ceil(x), // eslint-disable-line good-practices/no-single-usage-variable
      data,
      returnIndices = [],
      sortedData = dataset.config.JSONData && dataset.config.JSONData.data;
    for (i = sortedData.length; i--;) {
      data = sortedData[i];
      if (data.x >= minX && data.x <= maxX) {
        returnIndices.push(i);
      }
    }
    return returnIndices;
  },
  __parseToolText = function (i) {
    var dataset = this,
      conf = dataset.config,
      data = dataset.components.data, // eslint-disable-line good-practices/no-single-usage-variable
      chartAttr = dataset.getFromEnv('chart-attrib'),
      isLine = conf.plotType === LINE ? 1 : 0,
      toolText,
      BLANK = BLANKSTRING,
      setData = conf.JSONData.data[i],
      config = data[i].config,
      label = dataset.getFromEnv('xAxis').getLabel(config.x).label, // eslint-disable-line good-practices/no-single-usage-variable
      open = config.open,
      close = config.close,
      yAxis = dataset.getFromEnv('yAxis'),
      high = config.high,
      low = config.low,
      volume = config.volume,
      volumeToolText = volume !== UNDEF ? setData.volumetooltext : UNDEF; // eslint-disable-line good-practices/no-single-usage-variable

    // create the tooltext
    if (!conf.showTooltip) {
      toolText = BLANK;
    } else {
      toolText = getValidValue(parseUnsafeString(pluck(volumeToolText,
        setData.tooltext, conf.volumeToolText, conf.toolText), false));

      if (toolText !== UNDEF) {
        toolText = parseTooltext(toolText, [3, 5, 6, 10, 54, 55, 56, 57, 58, 59, 60, 61, 81, 82], {
          label: label,
          yaxisName: parseUnsafeString(chartAttr.yaxisname),
          xaxisName: parseUnsafeString(chartAttr.xaxisname),
          openValue: setData.open,
          openDataValue: yAxis.dataLabels(open),
          closeValue: setData.close,
          closeDataValue: yAxis.dataLabels(close),
          highValue: setData.high,
          highDataValue: yAxis.dataLabels(high),
          lowValue: setData.low,
          lowDataValue: yAxis.dataLabels(low),
          volumeValue: setData.volume,
          volumeDataValue: yAxis.dataLabels(volume)
        }, setData, chartAttr);
      } else {
        toolText = (open !== null && !isLine) ? BOLDSTARTTAG + 'Open:' + BOLDENDTAG + BLANKSPACE +
          yAxis.dataLabels(open) + BREAKSTRING : BLANK;
        toolText += close !== null ? BOLDSTARTTAG + 'Close:' + BOLDENDTAG + BLANKSPACE +
          yAxis.dataLabels(close) + BREAKSTRING : BLANK;
        toolText += (high !== null && !isLine) ? BOLDSTARTTAG + 'High:' + BOLDENDTAG + BLANKSPACE +
          yAxis.dataLabels(high) + BREAKSTRING : BLANK;
        toolText += (low !== null && !isLine) ? BOLDSTARTTAG + 'Low:' + BOLDENDTAG + BLANKSPACE +
          yAxis.dataLabels(low) + BREAKSTRING : BLANK;
        toolText += volume !== null ? BOLDSTARTTAG + 'Volume:' + BOLDENDTAG + BLANKSPACE +
          yAxis.dataLabels(volume) : BLANK;
      }
    }
    return toolText;
  };

addDep({
  name: 'candlestickAnimation',
  type: 'animationRule',
  extension: candlestickAnimation
});
/**
* Class def for bull stick chart API
* This dataset is reponsible for drawing stick depending on high and open value
*/
class CandleStickDataset extends ErrorBar2DDataset {
  /**
   * function to Remove data plots if the number of current data plots/categories
   * is more than the existing ones.
   * @param  {Object} datasetJSON JSON for dataset configurations
   */
  trimData (datasetJSON) {
    if (!this.components && this.components.data && this.components.data.length) {
      return;
    }
    let comps = this.components,
      prevData = comps && comps.data,
      prevDataLength = prevData && prevData.length, // eslint-disable-line good-practices/no-single-usage-variable
      data = datasetJSON.data,
      currDataLength = (Array.isArray(data) && data.filter(v => (v.high || v.open || v.close || v.low)).length) || 0, // eslint-disable-line good-practices/no-function-dependency
      dataDiff = prevDataLength - currDataLength;

    // Removing data plots if the number of current data plots
    // is less than the existing ones.
    if (dataDiff > 0) {
      this.removeData(currDataLength, dataDiff, false);
    }
  }
  /**
   * This Api is used to remove all the data objects which are not required anymore.
   * candleStick should use the removePlot of column dataset
   * @memberof CandleStickDataset
   */
  removePlots () {
    var dataset = this,
      components = dataset.components,
      removeDataArr = components && components.removeDataArr; // eslint-disable-line good-practices/no-single-usage-variable

    _removePlots(removeDataArr, dataset.__removeElem);
  }
  /**
    * Function for parsing all the attributes and value given by the user at chart,dataset and set level.
    * This function is called once from the init() function of the Column class.
    * @param  {Object} datasetJSON JSON for dataset configurations
    * @return {boolean} Indicates whether the configuration was successful or not
    */
  configureAttributes (datasetJSON) {
    if (!datasetJSON) {
      return false;
    }
    this.trimData(datasetJSON);
    this.config.JSONData = datasetJSON;

    var dataset = this,
      conf = dataset.config,
      chart = dataset.getFromEnv('chart'),
      JSONData = dataset.config.JSONData,
      dataArr = JSONData.data || [],
      chartAttr = chart.getFromEnv('dataSource').chart,
      dataLength = dataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      numberFormatter = dataset.getFromEnv('number-formatter'),
      colorM = dataset.getFromEnv('color-manager'),
      setColor,
      setBorderColor,
      setAlpha,
      // Candle stick properties.
      // Bear fill and border color - (Close lower than open)
      bearBorderColor = conf.bearBorderColor = // eslint-disable-line good-practices/no-single-usage-variable
                  getFirstColor(pluck(chartAttr.bearbordercolor, COLOR_B90000)),
      bearFillColor = conf.bearFillColor = // eslint-disable-line good-practices/no-single-usage-variable
                  getFirstColor(pluck(chartAttr.bearfillcolor, COLOR_B90000)),
      // Bull fill and border color - Close higher than open
      bullBorderColor = conf.bullBorderColor = // eslint-disable-line good-practices/no-single-usage-variable
                  getFirstColor(pluck(chartAttr.bullbordercolor,
                    colorM.getColor('canvasBorderColor'))),
      bullFillColor = conf.bullFillColor = // eslint-disable-line good-practices/no-single-usage-variable
              getFirstColor(pluck(chartAttr.bullfillcolor,
                COLOR_FFFFFF)),
      // Line Properties - Serves as line for bar & line and border for candle stick
      plotLineThickness = conf.linethickness = conf.plotBorderThickness =
                  pluckNumber(chartAttr.plotlinethickness, 1),
      plotLineDashLen = conf.plotLineDashLen = pluckNumber(chartAttr.plotlinedashlen, 5), // eslint-disable-line good-practices/no-single-usage-variable
      plotLineDashGap = conf.plotLineDashGap = pluckNumber(chartAttr.plotlinedashgap, 4), // eslint-disable-line good-practices/no-single-usage-variable

      pointShadow,
      index,
      dataObj,
      open,
      close,
      high,
      low,
      volume,
      minValue,
      maxValue,
      x,
      closeVal,
      borderColor,
      yVal,
      dataStore,
      setData,
      config,
      isCandleStick = false, // eslint-disable-line good-practices/no-single-usage-variable
      plotSpacePercent,
      yMax = -Infinity,
      yMin = +Infinity,
      xMax = -Infinity,
      xMin = +Infinity,
      userMaxColWidth;

    dataset.setState('visible', pluckNumber(JSONData.visible, 1) === 1);

    dataset._conatinerHidden = !!dataset.getState('visible');

    conf.minAbsNonZeroValue = Infinity;
    conf.minAbsNonZeroData = {};

    conf.defaultPadding = {
      left: 0.5,
      right: 0.5
    };
    conf.parentYAxis = 0;
    conf.toolText = getValidValue(parseUnsafeString(pluck(JSONData.tooltext, chartAttr.plottooltext), false));
    // Dataset seriesname
    conf.name = getValidValue(JSONData.seriesname);
    conf.showTooltip = pluckNumber(chartAttr.showtooltip, 1);
    conf.showShadow = pluckNumber(chartAttr.showshadow, colorM.getColor(SHOWSHADOW));
    conf.showErrorValue = true;
    conf.errorBarWidthPercent = 0;
    isCandleStick = true; // eslint-disable-line good-practices/no-single-usage-variable
    userMaxColWidth = pluck(chartAttr.maxcolwidth); // eslint-disable-line good-practices/no-single-usage-variable
    conf.maxColWidth = Math.abs(pluckNumber(
      userMaxColWidth, 50)) || 1;
    plotSpacePercent = Math.max(pluckNumber(chartAttr.plotspacepercent, 20) % 100, 0); // eslint-disable-line good-practices/no-single-usage-variable
    conf.plotSpacePercent = conf.groupPadding = plotSpacePercent / 200;
    dataStore = dataset.components.data = dataset.components.data || (dataset.components.data = []);
    conf.valuePadding = pluckNumber(JSONData.valuepadding, chartAttr.valuepadding, 2);
    conf.plotBorderThickness = plotLineThickness;
    // Iterate through all level data
    for (index = 0; index < dataLength; index += 1) {
      // Individual data obj
      // for further manipulation
      setData = dataArr[index];
      dataObj = dataStore[index];
      if (!dataObj) {
        dataObj = dataStore[index] = {};
      }
      !dataObj.config && (dataObj.config = {});
      !dataObj.graphics && (dataObj.graphics = {});
      config = dataObj.config;
      if (setData && !setData.vline) {
        config.setLink = pluck(setData.link);
        open = config.open = numberFormatter.getCleanValue(setData.open);
        close = config.close = numberFormatter.getCleanValue(setData.close);
        high = config.high = numberFormatter.getCleanValue(setData.high);
        low = config.low = numberFormatter.getCleanValue(setData.low);
        volume = config.volume = numberFormatter.getCleanValue(setData.volume, true);
        if (volume !== null) {
          chart.config.drawVolume = true;
        }
        x = config.x = numberFormatter.getCleanValue(setData.x);
        // openVal = config.openVal = isCandleStick ? Math.abs(close - open) : open;
        closeVal = config.closeVal = Math.min(open, close);
        yVal = config.yVal = Math.max(open, close);
        minValue = Math.min(open, close, high, low);
        maxValue = Math.max(open, close, high, low);

        config.valuePadding = pluckNumber(setData.valuepadding, conf.valuePadding);

        // valueText = parseUnsafeString(getValidValue(setData.valuetext, BLANK));

        setBorderColor = getFirstColor(pluck(setData.bordercolor, close < open ? bearBorderColor
          : bullBorderColor));
        setAlpha = pluckNumber(setData.alpha, 100);
        setColor = getFirstColor(pluck(setData.color, close < open ? bearFillColor
          : bullFillColor));
        config.dashed = pluckNumber(setData.dashed, 0);
        config.plotBorderDashStyle = pluckNumber(setData.dashed)
          ? getDashStyle(plotLineDashLen, plotLineDashGap) : DASH_DEF;
        // Set alpha of the shadow
        pointShadow = {
          opacity: conf.showShadow ? (setAlpha / 100) : 0
        };
        config.color = isCandleStick ? setColor : setBorderColor;
        config.alpha = setAlpha;
        /*
       * Storing the set level color and set level alpha which is required in drawing of line
       * In line we are checking setColor and setAlpha of current line segment is same as the previous
       * line segment's setColor and setAlpha by accesing config.setColor and config.setAlpha
       */
        config.setColor = config.color;
        config.setAlpha = config.alpha;
        config.anchorImageUrl = pluck(setData.anchorimageurl, JSONData.anchorimageurl, chartAttr.anchorimageurl);
        // Finally add the data
        // we call getPointStub function that manage displayValue, toolText and link
        borderColor = config.borderColor = setBorderColor;
        config.borderAlpha = config.plotLineAlpha;
        config.colorArr = [{
          color: config.color,
          alpha: config.alpha
        },
        {
          color: config.borderColor,
          alpha: config.borderAlpha
        }];

        config.showValue = 1;
        config.hoverEffects = {};

        config.y = Math.abs(close - open);
        config.previousY = closeVal;
        config.link = pluck(setData.link);
        config.errorValueArr = [];
        if (high - yVal > 0) {
          config.errorValue = true;
          config.errorValueArr.push({
            errorValue: yVal - high,
            errorStartValue: yVal,
            errorBarColor: borderColor,
            errorBarThickness: plotLineThickness,
            opacity: 1
          });
        }
        if (low - closeVal < 0) {
          config.errorValue = true;
          config.errorValueArr.push({
            errorValue: closeVal - low,
            errorStartValue: closeVal,
            errorBarColor: borderColor,
            errorBarThickness: plotLineThickness,
            opacity: 1
          });
        }
        config.setValue = yVal;

        if (yVal !== 0 && conf.minAbsNonZeroValue > Math.abs(yVal)) {
          conf.minAbsNonZeroValue = Math.abs(yVal);
          conf.minAbsNonZeroData = config;
        }

        config.dataLabelStyle = dataset._configureDataLabelStyle(setData);

        if (minValue !== null) {
          yMax = Math.max(yMax, minValue);
          yMin = Math.min(yMin, minValue);
        }
        if (maxValue !== null) {
          yMax = Math.max(yMax, maxValue);
          yMin = Math.min(yMin, maxValue);
        }
        if (x !== null) {
          xMax = Math.max(xMax, x);
          xMin = Math.min(xMin, x);
        }

        x = (x !== null) ? x : index + 1;
        config._x = x;
        config._y = yVal;
        config._b = closeVal;
        config.high = Math.max(open, close, high, low);
        config.low = Math.min(open, close, high, low);
        config.shadow = pointShadow;
        config.toolText = dataset._parseToolText(index);
        config.toolTipValue = BLANKSTRING;
        config.displayValue = parseUnsafeString(pluck(setData.displayvalue,
          setData.valuetext, BLANKSTRING));
      }
    }
    conf.yMax = yMax;
    conf.yMin = yMin;
    conf.xMax = xMax;
    conf.xMin = xMin;
    dataset.setState('dirty', true);
  }
  /**
   * parse tooltext from the dataset json
   * @param {number} i index of data
   * @return {string} tooltext
   */
  _parseToolText (i) {
    return __parseToolText.call(this, i);
  }
  /**
   * Adds dataset Specific event Arguments
   * @param {Object} _dataObj dataObject
   */
  // eslint-disable-next-line class-methods-use-this
  addDatasetSpecificEvtArgs (_dataObj) {
    let dataObj = _dataObj,
      config = dataObj.config,
      trackerConfig = dataObj.trackerConfig,
      eventArgs = trackerConfig.eventArgs;
    Object.assign(eventArgs, {
      open: config.open,
      close: config.close,
      high: config.high,
      low: config.low,
      volume: config.volume,
      alpha: config.alpha,
      x: config.x,
      displayValue: config.displayValue,
      color: config.color,
      borderColor: config.borderColor,
      dashed: config.dashed
    });
  }
  /**
   * calculate min and max position to scroll
   */
  calculateScrollRange () {
    let dataset = this,
      conf = dataset.config,
      dataLen = dataset.components.data && dataset.components.data.length; // eslint-disable-line good-practices/no-single-usage-variable
    conf.scrollMinVal = conf.scrollMinValForLabel = 0;
    conf.scrollMaxVal = conf.scrollMaxValForLabel = dataLen;
  }
  /**
   * fetches data indices wrt. the x pos value
   * @param {number} x  x pos value
   * @return {Array}    contains indices
   */
  getPlotIndices (x) {
    return getPlotIndices.call(this, x);
  }
  /**
   * Function that retunr the nearest plot details
   * @param {number} chartX x-axis position of the mouse cordinate
   * @param {number} chartY x-axis position of the mouse cordinate
   * @return {Object} return an object with details of nearest polt and whether it is hovered or not
   */
  _getHoveredPlot (chartX, chartY) {
    var dataset = this,
      x,
      i,
      hoveredInfo,
      pXs,
      pX;

    x = dataset.getFromEnv('xAxis').getValue(chartX);
    pXs = dataset.getPlotIndices(x);

    // Checking for overlap between two cosecutive column plots along x-axis
    for (i = pXs.length - 1; i > -1; i--) {
      pX = pXs[i];
      hoveredInfo = (pX - x > 0 ? dataset._checkPointerOverPlot(pX, chartX, chartY) ||
      dataset._checkPointerOverPlot(pX - 1, chartX, chartY)
        : dataset._checkPointerOverPlot(pX + 1, chartX, chartY) ||
            dataset._checkPointerOverPlot(pX, chartX, chartY));
      if (hoveredInfo) {
        break;
      }
    }
    return hoveredInfo;
  }
  /**
   * This method handles all mouse events of an dataset.
   * @param {string} eventType    name of the event
   * @param {number} plotIndex    index of the plot where this event has been occured
   * @param {Event}  e            reference of the original mouse event
   */
  _firePlotEvent (eventType, plotIndex, e) {
    _firePlotEvent.call(this, eventType, plotIndex, e);
  }
  /**
   * Function to get the maximum and minimum from dataset
   * @return {Object}     contains max, min value
   */
  getDataLimits () {
    var conf = this.config;
    return {
      max: conf.yMax,
      min: conf.yMin,
      xMax: conf.xMax,
      xMin: conf.xMin
    };
  }
  /**
   * Returns the name of the component
   *
   * @return {string} The name of the component
   */
  getName () {
    return 'candlestick';
  }
}

export default CandleStickDataset;
export { getPlotIndices, _firePlotEvent, __parseToolText as _parseToolText };
